import React, { useContext } from 'react';
import { AppStore } from './store';

export const createAppStoreContext = () => React.createContext<AppStore | undefined>(undefined);

export const AppStoreContext = createAppStoreContext();

export const useAppStoreContext: () => AppStore = () => {
    const context = useContext(AppStoreContext);
    if (!context) {
        throw new Error("useAppStoreContext must be used within an AppStoreProvider");
    }
    return context;
};

export const useAppStoreDispatch: () => AppStore["dispatch"] = () => {
    const context = useAppStoreContext();
    return context.dispatch.bind(context);
} 